// @flow
import {
  getAreDimensionsIncompleteForEstimateCC,
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC,
  getIfCCRowIsAdminEdited,
} from '@components/committed-capacity/utils';

import { useIsUserAdmin } from './useIsUserAdmin';

export const useIsRowInputDisabledForEstimateCC = ({
  dimensionRow,
  metricName,
  configuredMetrics,
}) => {
  const isUserAdmin = useIsUserAdmin();

  // Check if all the dimensions are set, if not, it should be disabled
  // Also, if there is any in progress row, outside of this row, then also, disable those guys, but enable this guy
  const isAnyOtherRowBesidesTheGivenRowBeingEdited =
    getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC(configuredMetrics, dimensionRow);

  const isNonAdminOnAdminEditedRow = !isUserAdmin && getIfCCRowIsAdminEdited(dimensionRow);
  const areDimensionsIncomplete = getAreDimensionsIncompleteForEstimateCC(dimensionRow, metricName);

  return (
    isNonAdminOnAdminEditedRow ||
    areDimensionsIncomplete ||
    isAnyOtherRowBesidesTheGivenRowBeingEdited
  );
};
